import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import logo from "./quixent_updated_logo.png";
import AuthModal from "./AuthModal";
import ProductModal from "./ProductModal";

function Header() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  // const [authMode, setAuthMode] = useState("login");
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);

  // Check authentication status on component mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsUserAuthenticated(true);
    }
  }, []);

  // Handle URL parameters for activation and auth
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const activated = params.get("activated");
      const auth = params.get("auth");
      const email = params.get("email");

      if (activated === "1" || activated === "0") {
        // User came from activation link - show product modal
        setShowProductModal(true);
        // Clean URL params
        const url = new URL(window.location.href);
        url.searchParams.delete("activated");
        url.searchParams.delete("auth");
        window.history.replaceState(
          {},
          document.title,
          url.pathname + url.search
        );
      } else if (auth === "login" || !!email) {
        // Direct auth request
        // setAuthMode("login");
        setIsAuthModalOpen(true);
        // Clean URL params
        const url = new URL(window.location.href);
        url.searchParams.delete("auth");
        window.history.replaceState(
          {},
          document.title,
          url.pathname + url.search
        );
      }
    } catch (_) {}
  }, []);

  // Toggle body scroll when mobile menu is open/closed
  useEffect(() => {
    if (isNavOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }

    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [isNavOpen]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const toggleNav = (e) => {
    e.preventDefault();
    setIsNavOpen(!isNavOpen);
  };

  const closeNav = () => {
    setIsNavOpen(false);
  };

  // const openAuthModal = (mode, e) => {
  //   if (e) e.preventDefault();
  //   setAuthMode(mode);
  //   setIsAuthModalOpen(true);
  //   closeNav();
  // };

  const handleAuthSuccess = (user) => {
    setIsAuthModalOpen(false);
    setIsUserAuthenticated(true);
    console.log("Authentication successful", user);

    // Always show product modal after successful authentication
    setTimeout(() => {
      setShowProductModal(true);
    }, 500);
  };

  const handleAuthRequest = (mode) => {
    setShowProductModal(false);
    // setAuthMode(mode);
    setIsAuthModalOpen(true);
  };

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      const nav = document.querySelector("nav");
      const hamburger = document.querySelector(".hamburger");

      if (
        isNavOpen &&
        nav &&
        !nav.contains(e.target) &&
        hamburger &&
        !hamburger.contains(e.target)
      ) {
        closeNav();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isNavOpen]);

  return (
    <div className="header-container">
      <motion.header
        className="header"
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <div className="header-content">
          <img
            src={logo}
            alt="Quixent Logo"
            className="logo"
            onClick={scrollToTop}
            style={{ cursor: "pointer" }}
          />

          <button
            className={`hamburger ${isNavOpen ? "active" : ""}`}
            onClick={toggleNav}
            aria-label="Toggle menu"
          >
            {isNavOpen ? "✕" : "☰"}
          </button>

          <nav className={isNavOpen ? "nav-open" : ""}>
            <ul className="nav-list">
              <li className="nav-item">
                <a
                  href="/"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToTop();
                    closeNav();
                  }}
                >
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#services"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .querySelector("#services")
                      ?.scrollIntoView({ behavior: "smooth" });
                    closeNav();
                  }}
                >
                  Services
                </a>
              </li>
              {/* <li className="nav-item">
                <a
                  href="#projects"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .querySelector("#projects")
                      ?.scrollIntoView({ behavior: "smooth" });
                    closeNav();
                  }}
                >
                  Our Projects
                </a>
              </li> */}
              <li className="nav-item">
                <a
                  href="#about"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .querySelector("#about")
                      ?.scrollIntoView({ behavior: "smooth" });
                    closeNav();
                  }}
                >
                  About
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#recruitment"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .querySelector("#recruitment")
                      ?.scrollIntoView({ behavior: "smooth" });
                    closeNav();
                  }}
                >
                  Staffing
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#testimonials"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .querySelector("#testimonials")
                      ?.scrollIntoView({ behavior: "smooth" });
                    closeNav();
                  }}
                >
                  Testimonials
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#privacy"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .querySelector("#privacy")
                      ?.scrollIntoView({ behavior: "smooth" });
                    closeNav();
                  }}
                >
                  Privacy Policy
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#contact"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .querySelector("#contact")
                      ?.scrollIntoView({ behavior: "smooth" });
                    closeNav();
                  }}
                >
                  Contact
                </a>
              </li>
            </ul>
            {/* Auth + Products buttons (stacked vertically) */}
            {/* <div className="auth-buttons-container">
             <button
                className="login-signup-btn"
                onClick={(e) => openAuthModal('login', e)}
               >
                Login/Sign Up
             </button>
              <button
                className="our-product-btn"
                onClick={(e) => {
                e.preventDefault();
                setShowProductModal(true);
                closeNav();
               }}
             >
            OUR PRODUCT
            </button>
            </div> */}
          </nav>

          {isNavOpen && (
            <div
              className="mobile-menu-overlay"
              onClick={closeNav}
              role="button"
              tabIndex="0"
              onKeyDown={(e) => e.key === "Escape" && closeNav()}
            />
          )}
        </div>
      </motion.header>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
        onAuthSuccess={handleAuthSuccess}
      />

      <ProductModal
        isOpen={showProductModal}
        onClose={() => setShowProductModal(false)}
        isUserAuthenticated={isUserAuthenticated}
        onAuthRequest={handleAuthRequest}
      />

      <a
        href="https://api.whatsapp.com/send?phone=919176122210"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-icon"
        aria-label="Chat with us on WhatsApp"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
        />
      </a>
    </div>
  );
}

export default Header;
